import { render, staticRenderFns } from "./DocumentSplitter.vue?vue&type=template&id=51f92b2c&"
import script from "./DocumentSplitter.vue?vue&type=script&lang=js&"
export * from "./DocumentSplitter.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSplitter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports